import type { Map as MapboxMap } from 'mapbox-gl'

const noRepaint = () => {}

/**
 * Holds a map's drawing while it is out of sight. Mapbox draws a frame only when asked (`triggerRepaint`: a tile
 * arriving, a camera move, its terrain settling, a resize), so while held its asks go unanswered. Tiles already asked
 * for still arrive. Letting go draws one frame: the map as it is now (a move made meanwhile where it ended), at its
 * size now. Returns the release.
 */
export function holdRepaints(map: Pick<MapboxMap, 'triggerRepaint'>): () => void {
  const repaint = map.triggerRepaint
  map.triggerRepaint = noRepaint
  return () => {
    map.triggerRepaint = repaint
    map.triggerRepaint()
  }
}
